(function () {
  function perView(root) {
    var d = parseInt(root.getAttribute('data-lv-per-desktop') || '3', 10);
    var m = parseInt(root.getAttribute('data-lv-per-mobile') || '1', 10);
    if (typeof window !== 'undefined' && window.matchMedia) {
      if (window.matchMedia('(min-width: 1200px)').matches) return Math.max(1, d);
      return Math.max(1, m);
    }
    return Math.max(1, d);
  }

  var MAX_DOTS = 10;

  function pageCount(slides, pv) {
    if (!slides.length) return 0;
    return Math.max(1, Math.ceil(slides.length / pv));
  }

  function pageStartIndex(page, slideCount, pv) {
    var lastStart = Math.max(0, slideCount - pv);
    return Math.min(page * pv, lastStart);
  }

  function activePageIndex(track, slides, pv, pages) {
    var scroll = track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var p = 0; p < pages; p++) {
      var slide = slides[pageStartIndex(p, slides.length, pv)];
      if (!slide) continue;
      var dist = Math.abs(slide.offsetLeft - scroll);
      if (dist < bestDist) {
        bestDist = dist;
        best = p;
      }
    }
    return best;
  }

  function renderDots(dotsWrap, count, activeIndex, labelPrefix) {
    if (!dotsWrap) return;
    if (count < 2 || count > MAX_DOTS) {
      dotsWrap.innerHTML = '';
      dotsWrap.hidden = true;
      return;
    }
    dotsWrap.hidden = false;
    var dots = dotsWrap.querySelectorAll('[data-lv-dot]');
    if (dots.length !== count) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lv-dot';
        btn.setAttribute('data-lv-dot', String(i));
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', (labelPrefix || 'Slide') + ' ' + (i + 1));
        dotsWrap.appendChild(btn);
      }
    }
    dotsWrap.querySelectorAll('[data-lv-dot]').forEach(function (dot, i) {
      var on = i === activeIndex;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.lvInit === '1') return;
    var track = root.querySelector('[data-lv-track]');
    var slides = track ? root.querySelectorAll('[data-lv-slide]') : [];
    var dotsWrap = root.querySelector('[data-lv-dots]');
    if (!track || !slides.length) return;

    root.dataset.lvInit = '1';

    var index = 0;
    var pv = perView(root);
    var pages = pageCount(slides, pv);
    var maxIndex = Math.max(0, pages - 1);
    var dotLabel = dotsWrap ? dotsWrap.getAttribute('data-lv-dot-label') || 'Slide' : 'Slide';
    var autoplayMs = parseInt(root.getAttribute('data-lv-autoplay-ms') || '0', 10);
    var timer = null;

    function syncPages() {
      pv = perView(root);
      pages = pageCount(slides, pv);
      maxIndex = Math.max(0, pages - 1);
      if (index > maxIndex) index = maxIndex;
      renderDots(dotsWrap, pages, index, dotLabel);
    }

    function scrollToIndex(i, behavior) {
      index = Math.max(0, Math.min(i, maxIndex));
      var slide = slides[pageStartIndex(index, slides.length, pv)];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      renderDots(dotsWrap, pages, index, dotLabel);
    }

    function onScrollEnd() {
      index = activePageIndex(track, slides, pv, pages);
      renderDots(dotsWrap, pages, index, dotLabel);
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(onScrollEnd, 80);
    });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-lv-dot]');
        if (!dot) return;
        var i = parseInt(dot.getAttribute('data-lv-dot'), 10);
        if (isNaN(i)) return;
        scrollToIndex(i);
        resetAutoplay();
      });
    }

    function resetAutoplay() {
      if (timer) window.clearInterval(timer);
      if (autoplayMs < 1000) return;
      timer = window.setInterval(function () {
        syncPages();
        var next = index >= maxIndex ? 0 : index + 1;
        scrollToIndex(next);
      }, autoplayMs);
    }

    function onResize() {
      syncPages();
      scrollToIndex(index, 'auto');
    }

    window.addEventListener('resize', onResize);
    syncPages();
    resetAutoplay();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-lv-section]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      e.target.querySelectorAll('[data-lv-section]').forEach(function (el) {
        delete el.dataset.lvInit;
      });
      boot(e.target);
    }
  });
})();
